import { PropertyTypeID } from '@klokhuis/core/ApiClient/Klokhuis';

const propertyTypeMapping: { [key: string]: PropertyTypeID } = {
  residentialland: PropertyTypeID.ResidentialLand,
  houseorvilla: PropertyTypeID.HouseOrVilla,
  farmland: PropertyTypeID.FarmLand,
  commercialproperties: PropertyTypeID.CommercialLand,
};

// For routes with a property type and secondary value separate by a dash. Eg: /farmland-chennai
export function getPropertyTypeAndValueFromRoute(
  typeAndValue: string | undefined,
) {
  const parts = typeAndValue?.split('-') || [];
  const propertyType = (parts[0] || '').toLowerCase();
  let value = (parts[1] || '').toLowerCase();
  value = parts.filter((_, index) => index > 0).join('-');
  return { propertyType, value };
}

export function getPropertyTypeTextToIDMapping(typeAndCity: string) {
  const { propertyType } = getPropertyTypeAndValueFromRoute(typeAndCity);

  return propertyTypeMapping[propertyType];
}
